import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AgencyService } from '@core/services/agency.service';
import { DownloadRequestService } from '@core/services/download-request.service';
import { map, switchMap, take } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'drdp-download-demographics',
    templateUrl: './download-demographics.component.html',
    styleUrls: ['./download-demographics.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DownloadDemographicsComponent implements OnInit {
  is2025Page: boolean = false;
  title: string = '';
  downloadService = inject(DownloadRequestService);
  agencyService = inject(AgencyService);
  private route = inject(ActivatedRoute);
  constructor(private translocoService: TranslocoService) {}

  ngOnInit(): void {
    this.is2025Page = this.route.snapshot.data['isEarlyAdopter'] ?? false;
    this.title = this.translocoService.translate('downloads.demographics.title', {
      year: this.is2025Page ? '2025' : '2015',
    });
  }

  downloadDemographics(searchValues: any) {
  searchValues = { ...searchValues, isEarlyAdopter: this.is2025Page };

  this.agencyService.getAgency(searchValues.agencyId).pipe(
    take(1),
    switchMap((agency: any) => {
      const agencyName = (agency?.agencyName ?? 'demographics').replace(/ /g, '_');
      const date = new Date().toISOString().slice(0, 10);

      return this.downloadService.downloadDemographics(searchValues).pipe(
        take(1),
        map((res) => ({ res, agencyName, date }))
      );
    })
  ).subscribe(({ res, agencyName, date }) => {
    const file = new Blob([res], { type: 'text/csv' });
    const fileUrl = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = `${agencyName}_${date}.csv`;
    link.click();
  });
}
}
